import { render } from "./IbanForm.vue?vue&type=template&id=e59597ce&ts=true"
import script from "./IbanForm.vue?vue&type=script&lang=ts"
export * from "./IbanForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__